export enum eCommand {
  /**
   * 唤醒
   */
  AWAKE = 1,
  /**
   * 重启
   */
  RESTART = 2,
  /**
   * 关机
   */
  CLOSE = 3,
  /**
   * 维护
   */
  REPAIR = 4,
  /**
   * 取消维护
   */
  CANCEL_REPAIR = 5,
  /**
   * 删除
   */
  DELETE = 6,
  /**
   * 退还
   */
  RETURN = 7,
}

export enum eDispatch {
  /**
   * 不存在
   */
  NO = 0,
  /**
   * 已开机
   */
  OPEN = 1,
  /**
   * 等待开机
   */
  WAIT_OPEN = 2,
  /**
   * 已调度
   */
  DISPATCH = 3,
  /**
   * 等待重启
   */
  WAIT_RESTART = 4,
  /**
   * 已关机
   */
  CLOSE = 5,
  /**
   * 等待关机
   */
  WAIT_CLOSE = 6,
}

export enum ePowerMode {
  /**
   * 开启白名单
   */
  START = 1,
  /**
   * 关闭白名单
   */
  CLOSE = 2,
}

export enum eConfigId {
  /**
   * 全部配置
   */
  All,
  /**
   * 普通配置
   */
  NORMAL,
  /**
   * 高配
   */
  ADVANCED,
  /**
   * 体验服
   */
  EXPERIENCE,
}
/* 设备当前状态
 */
export enum eDeviceStatus {
  /* 使用
   */
  USE = 1,
  /* 空闲 */
  FREE = 2,
  /* 离线 */
  OFFLINE = 3,
  /* 故障 */
  FAULT = 4,
  /* 维护 */
  MAINTAIN = 5,
  /* 删除 */
  DELETE = -1,
}
/* 计费方式 1:云币，2:体验，3:周期卡
 */
export enum eBillingMethod {
  /* 云币
   */
  CLOUDCION = 1,
  /* 体验 */
  EXPERIENCE = 2,
  /* 周期卡 */
  CYCLECARD = 3,
  /**
   * 云更新营销管理
   */
  CLOUDUPDATE = 4,
}
/* 广告位置   操作类型
 */
export enum eOptionType {
  /* 跳转链接
   */
  JUMPLINK = 'link',
  /* 启动三方应用 */
  STARTAPP = 'start',
  /* 跳转本应用的其他页面 */
  JUMPPAGE = 'page',
  /* Gameid */
  GAME = 'game',
}
/* 推广渠道 'BGW':官网:用户分享'D'，'A':渠道投放。'B'云更新菜单
 */
export enum eExtensionLaunch {
  /* 官网
   */
  WEBSITE = 'BGW',
  /* 用户分享 */
  USERSHARE = 'D',
  /* 渠道投放 */
  CHANNELLAUNCH = 'A',
  /* 云更新菜单 */
  ClOUDMUEN = 'B',
}

/***
 * 消费类型
 */
export enum econsumptionType {
  /* 官网
   */
  '官网' = 4,
  /* pc */
  'PC' = 1,
  /* 云盒子 */
  '云盒子' = 3,
  /* 云更新菜单 */
  '安卓' = 2,
  'IOS' = 5,
}
export enum eSortType {
  /** 升序  */
  ASC = 0,
  /** 降序  */
  DES = 1,
}
/***
 * 充值查询
 */
export enum ePayType {
  /* /系统充值
   */
  '系统充值' = -1,
  /* 未知
   */
  '未知' = 0,
  /* 微信 */
  '微信' = 1,
  /* 兑换码 */
  '兑换码' = 2,
  /* 支付宝 */
  '支付宝' = 3,

  /* 推广码
   */
  '推广码' = 6,
  /* 福利任务
   */
  '福利任务' = 4,
  /* 苹果内购
   */
  'IOS' = 7,
}

/***
 * 消费查询
 */
export enum eClientType {
  /* PC */
  'PC' = 1,
  /* 安卓端 */
  '安卓' = 2,
  /* 盒子端 */
  '盒子' = 3,

  /* WebRTC 端
   */
  'WebRTC' = 4,
  /*  IOS 端
   */
  ' IOS' = 5,
  /* 苹果内购
   */
}
